import { MarketCountryCode } from '@axo/shared/types';
import { ReactNode } from 'react';
import type { Country } from '@axo/config/@types/Country.types';

export type TProvidersProps = {
  Criipto?: {
    country: MarketCountryCode | Country;
    label?: string;
    className?: string;
    /** note : conflicts with next.js router / global auth redirect */
    shouldClearHash?: boolean;
  };
  Vipps?: {
    label?: 'login' | 'continue';
    className?: string;
    /** note : conflicts with next.js router / global auth redirect */
    shouldClearHash?: boolean;
  };
  BankID?: {
    label?: string;
    serviceSourceUrl?: string;
    className?: string;
  };
  ESkat?: {
    children: ReactNode;
    applicationID?: string;
    token?: string;
    hasIcon?: boolean;
    className?: string;
  };
};

export enum TProviders {
  Criipto = 'Criipto',
  BankID = 'BankID',
  ESkat = 'ESkat',
  Vipps = 'Vipps',
}

/**
 * FIXME there's a difference between a provider and integrator
 *
 * export enum TIntegrators {
 *   Criipto = 'Criipto',
 *   Assently = 'Assently',
 * }
 *
 * export enum TProviders {
 *   BankID = 'BankID',
 *   ESkat = 'ESkat',
 *   Vipps = 'Vipps',
 * }
 */
